var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuawei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63692 0.5C2.67912 0.5 0.5 2.67874 0.5 8.63533V21.3647C0.5 27.3213 2.67912 29.5 8.63692 29.5H21.3592C27.3168 29.5 29.5 27.3213 29.5 21.3647V8.63533C29.5 2.67874 27.3209 0.5 21.3631 0.5H8.63692Z",
    fill: "url(#paint0_linear_197_128)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1497 17.3194H14.3139L13.7298 15.961L13.1497 17.3194ZM12.863 18.004L12.5176 18.7943H11.7312L13.4035 15.0002H14.0832L15.7488 18.7943H14.9414L14.6004 18.004H12.863ZM25.5177 18.7915H26.2778V15H25.5177V18.7915ZM22.4925 17.1628H23.8936V16.4714H22.4925V15.6944H24.5264V15.0028H21.7327V18.7941H24.5996V18.1026H22.4925V17.1628ZM19.4725 17.6107L18.6108 15H17.9819L17.1202 17.6107L16.2816 15.0021H15.4616L16.7851 18.7964H17.4225L18.2856 16.3041L19.1487 18.7964H19.7918L21.1118 15.0021H20.313L19.4725 17.6107ZM10.5709 17.1733C10.5709 17.7905 10.2644 18.1203 9.70777 18.1203C9.14814 18.1203 8.84001 17.7809 8.84001 17.1469V15.0026H8.06967V17.1733C8.06967 18.241 8.6631 18.8533 9.69728 18.8533C10.7417 18.8533 11.3405 18.2293 11.3405 17.1416V15.0002H10.5709V17.1733ZM6.23182 15.0002H7.00169V18.7967H6.23182V17.2548H4.49256V18.7967H3.72223V15.0002H4.49256V16.5316H6.23182V15.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.1666C12.3346 10.1666 10.1667 7.99839 10.1667 5.33325H10.8494C10.8494 7.62172 12.7115 9.48363 15 9.48363C17.2885 9.48363 19.1506 7.62172 19.1506 5.33325H19.8333C19.8333 7.99839 17.6651 10.1666 15 10.1666Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_128",
    x1: 15,
    y1: 0.5,
    x2: 15,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3E45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuawei);
export default __webpack_public_path__ + "static/media/huawei.b7062b2e0a79e879c1e4d335263cb8df.svg";
export { ForwardRef as ReactComponent };